import { Skeleton } from '@/components/ui/skeleton';

export const PricingSkeleton = () => {
	return (
		<div className="flex min-h-[520px] flex-col overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm md:flex-row md:overflow-visible">
		{Array.from({ length: 4 }).map((_, index) => (
			<div
				key={index}
				className="flex w-full flex-1 flex-col p-8"
			>
				<div className="mb-6 flex flex-col gap-3 md:mb-0 md:min-h-[140px] lg:mt-4">
					<Skeleton className="h-5 w-24" />
					<Skeleton className="h-11 w-32" />
				</div>
				<div className="mb-4 mt-2">
					<Skeleton className="h-11 w-full" />
				</div>
				<div className="mt-6 space-y-3">
					{Array.from({ length: 5 }).map((__, fIdx) => (
						<Skeleton
							key={fIdx}
							className="h-4 w-full"
						/>
					))}
				</div>
			</div>
		))}
		</div>
	);
};
